<template>
  <div class="containar">
    <div style="float: left;width: 100%;height: 20%">
      <div id="logoDiv">
        <img src="../../../static/img/logo.png" id="logo">
      </div>
      <div id="logotextDiv">
        <span style="font-size: 20px">甘肃智通科技工程检测咨询有限公司</span><br>
        <span style="font-size: 20px">Gansu ZhiTong Technology Enginnering Detection Consulting Co.,LTD</span><br>
        <span style="font-weight:bold;font-size: 30px">公路工程试验检测资产管理系统</span><br>
        <span style="font-weight:bold;font-size: 10px">MANAGEMENT SYSTEM OF HIGHWAY ENGINEERING TEST AND DETECTION
          EQUIPMENT2.0</span><br>
      </div>
    </div>
    <div id="logoimgDiv">
      <img src="../../../static/img/bg2.png" style="height: 100%;width: 100%">
    </div>
    <div id="loginFormDiv">
      <p style="text-align: left;margin-left: 15px;height: 25px;line-height: 50px;font-size: 20px;">欢迎登录</p>
      <!-- 绑定账号表单 -->
      <div v-if="needBind" style="padding: 15px 20px;">
        <p style="color:#E6A23C;font-size:13px;margin-bottom:15px;">该钉钉账号未绑定系统用户，请绑定已有账号</p>
        <el-input v-model="bindUserId" placeholder="请输入账号" style="margin-bottom:12px;" clearable></el-input>
        <el-input v-model="bindPassword" placeholder="请输入密码" type="password" style="margin-bottom:16px;" clearable show-password></el-input>
        <el-button type="primary" style="width:100%;" @click="doBindDingTalk" :loading="logging">绑定并登录</el-button>
        <div style="text-align:center;margin-top:12px;">
          <a href="javascript:;" @click="needBind=false" style="color:#409EFF;font-size:13px;">返回扫码</a>
        </div>
      </div>
      <!-- 二维码区域 -->
      <div v-else>
        <div id="login_container"></div>
        <div><router-link to="/login" class="login"><span><a>账号密码登录</a></span></router-link></div>
      </div>
    </div>
    <!-- 钉钉登录中 loading 遮罩 -->
    <div class="loading-mask" v-if="logging">
      <div class="loading-box">
        <i class="el-icon-loading" style="font-size: 36px; color: #409EFF;"></i>
        <p style="margin-top: 16px; color: #333;">钉钉登录中，请稍候...</p>
      </div>
    </div>
    <FooterBar />
  </div>
</template>

<script>
import { dingdingLogin, getDingTalkConfig, bindDingTalk } from '../../api/api'
import FooterBar from '../../components/FooterBar'
export default {
  components: { FooterBar },
  data() {
    return {
      logging: false,
      needBind: false,
      bindUnionId: '',
      bindUserId: '',
      bindPassword: '',
      redirect: undefined,
      appid: '',
      redirectUrl: '',
      dingCodeConfig: {
        id: 'login_container',
        style: 'border:none;background-color:#FFFFFF;margin-top:10px',
        width: "100%",//官方参数 365
        height: "300"//官方参数 400
      }
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    },
    needBind(val) {
      // 从绑定表单返回扫码时，重建二维码
      if (!val) {
        this.$nextTick(() => {
          this.initDingLogin()
        })
      }
    }
  },
  computed: {
    getRedirectUrl() {
      return encodeURIComponent(this.redirectUrl)
    },
    getAuthUrl() {
      return `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${this.appid}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${this.getRedirectUrl}`
    },
    getGoto() {
      return encodeURIComponent(this.getAuthUrl)
    },
    getDingCodeConfig() {
      return { ...this.dingCodeConfig, goto: this.getGoto }
    }
  },
  created() {
    this.initDingJs()
    this.fetchDingConfig()
    // 如果是钉钉扫码回调（sessionStorage 标记或 URL 带 code），立即显示 loading
    if (sessionStorage.getItem('ddScanning') === '1' || window.location.hash.indexOf('?code=') > 0) {
      this.logging = true
    }
  },
  mounted() {
    this.addDingListener()
    this.getUser()
  },
  methods: {
    // 从后端获取钉钉配置
    fetchDingConfig() {
      getDingTalkConfig().then(res => {
        if (res.status == 200 && res.data) {
          this.appid = res.data.appId
          this.redirectUrl = res.data.redirectUri
          // 配置加载完成后初始化钉钉登录二维码
          this.$nextTick(() => {
            this.initDingLogin()
          })
        } else {
          this.$message({ message: '获取钉钉配置失败', type: 'error' })
        }
      }).catch(() => {
        this.$message({ message: '获取钉钉配置失败', type: 'error' })
      })
    },
    initDingJs() {
      !function (window, document) {

        function d(a) {
          var e, c = document.createElement('iframe'),
            d = 'https://login.dingtalk.com/login/qrcode.htm?goto=' + a.goto
          d += a.style ? '&style=' + encodeURIComponent(a.style) : '',
            d += a.href ? '&href=' + a.href : '',
            c.src = d,
            c.frameBorder = '0',
            c.allowTransparency = 'true',
            c.scrolling = 'no',
            c.width = a.width ? a.width + 'px' : '365px',
            c.height = a.height ? a.height + 'px' : '400px',
            e = document.getElementById(a.id),
            e.innerHTML = '',
            e.appendChild(c)
        }

        window.DDLogin = d

      }(window, document)
    },
    addDingListener() {

      let self = this

      let handleLoginTmpCode = function (loginTmpCode) {
        // 扫码后标记，回调页面加载时立即显示 loading
        sessionStorage.setItem('ddScanning', '1')
        window.location.href = self.getAuthUrl + `&loginTmpCode=${loginTmpCode}`
      }

      let handleMessage = function (event) {
        if (event.origin == 'https://login.dingtalk.com') {
          handleLoginTmpCode(event.data)
        }
      }

      if (typeof window.addEventListener != 'undefined') {
        window.addEventListener('message', handleMessage, false)
      } else if (typeof window.attachEvent != 'undefined') {
        window.attachEvent('onmessage', handleMessage)
      }

    },
    initDingLogin() {
      window.DDLogin(this.getDingCodeConfig)
    },
    getUser() {
      let getQueryString = function (name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
        // var r = window.location.hash.substr(1).match(reg)
        let path = window.location.hash
        let r = "";
        if (path.indexOf("?") > 0) {
          r = window.location.hash.split("?")[1].split("=")[1].split("&")[0]
        } else {
          r = null
        }
        return r

      }
      let code = getQueryString('code')
      if (code !== null) {
        this.logging = true
        let _params = {
          authCode: code
        }
        dingdingLogin(_params).then(datas => {
          let { status, message, data } = datas
          if (status == 400 || status == -1) {
            this.$message({
              message: message || '登录失败',
              type: 'error'
            })
            sessionStorage.removeItem('ddScanning')
            this.logging = false
          } else if (status == 200) {
            // 登录成功，存储用户信息到 localStorage
            localStorage.setItem("user", JSON.stringify(data))
            localStorage.setItem("token", new Date().getTime())
            localStorage.setItem("theme", "#0680c7")
            localStorage.setItem("header", "#10a1d2")
            localStorage.setItem("loading", false)
            sessionStorage.removeItem('ddScanning')
            this.$message({ message: '钉钉登录成功', type: 'success' })
            // 检查是否需要强制修改初始密码
            setTimeout(() => {
              this.logging = false
              if (data.pwdChanged === 0 || data.pwdChanged === '0') {
                this.$router.push({ path: "/forceChangePwd" })
              } else {
                this.$router.push({ path: "/DeviceInfo", name: "设备信息", title: "设备信息" })
              }
            }, 1000)
          } else if (status == 300) {
            // 需要绑定系统账号
            sessionStorage.removeItem('ddScanning')
            this.logging = false
            this.bindUnionId = data.unionId
            this.needBind = true
          } else {
            this.$message({
              message: '请求错误，请重试',
              type: 'error'
            })
            sessionStorage.removeItem('ddScanning')
            this.logging = false
          }
        }).catch(() => {
          this.$message({
            message: '网络异常，请重试',
            type: 'error'
          })
          sessionStorage.removeItem('ddScanning')
          this.logging = false
        })
      }
    },
    // 绑定钉钉账号
    doBindDingTalk() {
      if (!this.bindUserId) {
        this.$message({ message: '请输入账号', type: 'warning' })
        return
      }
      if (!this.bindPassword) {
        this.$message({ message: '请输入密码', type: 'warning' })
        return
      }
      this.logging = true
      let _params = {
        unionId: this.bindUnionId,
        userId: this.bindUserId,
        password: this.bindPassword
      }
      bindDingTalk(_params).then(datas => {
        let { status, message, data } = datas
        if (status == 200) {
          // 绑定成功，登录
          localStorage.setItem("user", JSON.stringify(data))
          localStorage.setItem("token", new Date().getTime())
          localStorage.setItem("theme", "#0680c7")
          localStorage.setItem("header", "#10a1d2")
          localStorage.setItem("loading", false)
          this.$message({ message: '绑定成功，已登录', type: 'success' })
          setTimeout(() => {
            this.logging = false
            if (data.pwdChanged === 0 || data.pwdChanged === '0') {
              this.$router.push({ path: "/forceChangePwd" })
            } else {
              this.$router.push({ path: "/DeviceInfo", name: "设备信息", title: "设备信息" })
            }
          }, 1000)
        } else {
          this.$message({ message: message || '绑定失败', type: 'error' })
          this.logging = false
        }
      }).catch(() => {
        this.$message({ message: '网络异常，请重试', type: 'error' })
        this.logging = false
      })
    }

  }
}
</script>

<style scoped>
body {
  margin: 0px;
  padding: 0px;
  /*background: url(assets/bg1.jpg) center !important;
      background-size: cover;*/
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}

.containar {
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100vw;
  background-color: #255F9E;
  caret-color: transparent;
  user-select: none;
}

#logoDiv { width: 90px; height: 90px; margin-left: 15px; }
#logo { width: 100%; height: 100%; }
#logotextDiv {
  position: absolute; left: 120px; top: 1%; width: 700px; height: 10%;
  text-align: left; color: white;
}
#logoimgDiv { width: 40%; height: 73%; }

#loginFormDiv { user-select: text; caret-color: auto; }

.login {
  color: black;
  text-decoration: none;
}

#loginFormDiv {
  position: relative; left: 65%; bottom: 45%; background-color: white;
  border-radius: 5%; width: 350px;
  padding-bottom: 20px;
}

/* .login_content{
  margin-top: 20px!important ;
} */
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.loading-box {
  background: #fff;
  border-radius: 8px;
  padding: 30px 50px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}
</style>


// WEBPACK FOOTER //
// src/views/users/DingDing.vue